/**
 * This controller is for the "Connection Logs" Table, the job of this class is to transform ui filters into api calls and set the data in the model.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var lpMessagingEngagementHistoryTableAdapter = require('web-agent-adapters/lpMessagingEngagementHistoryTableAdapter');
    var lpBaseListController = require('web-agent-assets-js/lpBaseListController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var lpFileSharingController = require('web-agent-assets-js/lpFileSharingController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var DurationInputViewController = require('web-agent-viewControllers/DurationInputViewController');
    var BASE = lpBaseListController;
    var APPLICATION_TYPE = 'lpAMSEngagementHistoryListController';
    var MAX_TIME_DIFF = (1000 * 60 * 60 * 24) * 90;

    var defaultTimeRange = (1000 * 60 * 60 * 24) * 7; //7 days
    var defaultTimeSearchSettings = {
        from: Date.now() - defaultTimeRange,
        to: "Now"
    };

    var lpAMSEngagementHistoryListController = BASE.extend(function (options) {
        this.errorsCount = 0;
        this.stopPollingHandler = null;
        this.service = options.service;
        this.isManagerViewMode = options.isManagerViewMode;
        this.hasViewOtherConvPrivilege = options.hasViewOtherConvPrivilege;
    });

    lpAMSEngagementHistoryListController.prototype.applicationType = APPLICATION_TYPE;

    lpAMSEngagementHistoryListController.prototype.settings = {
        maxErrorsBeforeDisplayErrorState: 3,
        poolingInterval: 20000, // 20 Sec.
        defaultSearch: {
            query: {
                offset: 0,
                limit: 50,
                sort: "start:desc"
            },
            body: {
                start: {
                    from: defaultTimeSearchSettings.from,
                    to: defaultTimeSearchSettings.to
                },
                status: [
                    lpAMSController.CONVERSATION_STATES.OPEN,
                    lpAMSController.CONVERSATION_STATES.CLOSE
                ]
            }
        },
        defaultSearchUIData: {
            limit: 50,
            skip: 0,
            sortTag: "start",
            sortOrder: "desc",
            filters: {
                start: {
                    from: defaultTimeSearchSettings.from,
                    to: defaultTimeSearchSettings.to
                }
            }
        }
    };

    // Overriding the base functions (startPolling,stopPolling,isPolling), taking over the polling and delegating it to the service.
    //-------------------------------
    lpAMSEngagementHistoryListController.prototype.startPolling = function () {
        this.fetch();
    };

    lpAMSEngagementHistoryListController.prototype.stopPolling = function () {
        if (this.stopPollingHandler) {
            this.stopPollingHandler();
            this.stopPollingHandler = null;
        }
        this.clearState();
    };

    lpAMSEngagementHistoryListController.prototype.isPolling = function () {
        return _.isFunction(this.stopPollingHandler);
    };

    lpAMSEngagementHistoryListController.prototype.fetch = function () {
        this.stopPolling();
        this.errorsCount = 0;

        // if we are in a fetching state, cancel the fetch process.
        if (this.getStatus() === BASE.STATES.FETCHING) {
            return;
        }

        this.logger.debug('setting "Fetching" state.');
        this.setState(BASE.STATES.FETCHING);
        this.logger.debug('sending request to the engagement history service.');
        var reqObj = this.createRequestDataObject();
        this.stopPollingHandler = this.service.searchEngagements(reqObj);
    };

    lpAMSEngagementHistoryListController.prototype.getModelPaths = function () {
        return {
            state: 'connectionsLogs.state',
            count: 'connectionsLogs.count',
            lastQuery: 'connectionsLogs.lastQuery',
            array: 'connectionsLogs.array',
            data: 'connectionsLogs.data',
            metadata: 'connectionsLogs.metadata',
            modelLocationName: 'connectionsLogs',
            agentNames: 'operators.array'
        };
    };

    lpAMSEngagementHistoryListController.prototype.onSelectedItemChanged = function (data) {
        var selectedItemId = data && data.selectedItemId;
        var selectedItemStatus = this.model.get(this.getModelPaths().metadata + '.' + selectedItemId + '.state');

        if (selectedItemId && (selectedItemStatus === null || selectedItemStatus === BASE.STATES.ERROR)) {
            this.loadPartialConversation({conversationId: data.selectedItemId});
        }
    };


    lpAMSEngagementHistoryListController.prototype.handleSearchSuccess = function (response) {
        var self = this;
        var selectedItemId = this.selectedItemId;
        var selectedItemIndex = _.findIndex(response.data, function (item) { return item && item.chatData && item.chatData.chatInfo && item.chatData.chatInfo.chatId && item.chatData.chatInfo.chatId === selectedItemId; });
        if (selectedItemIndex !== -1) {
            processSelectedItemData();
        } else {
            updateModelData();
        }

        function processSelectedItemData() {
            // Find the Item Element in the responses.
            var currentSelectedItemDataObject       = self.model.get(self.getModelPaths().data + '.' + selectedItemId);
            var currentSelectedItemMetaDataObject   = self.model.get(self.getModelPaths().metadata + '.' + selectedItemId);

            var latestAgentId       =  currentSelectedItemMetaDataObject && currentSelectedItemMetaDataObject.latestAgentId;
            var conversationStart   =  currentSelectedItemDataObject && currentSelectedItemDataObject.chatInfo && currentSelectedItemDataObject.chatInfo.startTime;

            self.requestSingleConversation({
                conversationId      : selectedItemId,
                latestAgentId       : latestAgentId,
                conversationStart   : conversationStart,
                onSuccess           : function (resp){
                    // Setting the state to Success.
                    if(resp && resp.data && resp.data.length){
                        response.data[selectedItemIndex] = resp && resp.data[0];
                        response.data[selectedItemIndex].metaData.state = BASE.STATES.FETCHED;
                    }
                    updateModelData();
                },
                onError             : function (err){
                    // Setting the State to Error.
                    if(currentSelectedItemDataObject && currentSelectedItemMetaDataObject){
                        currentSelectedItemMetaDataObject.state = BASE.STATES.ERROR;
                        response.data[selectedItemIndex] = {
                            chatData: lpUtils.cloneObject(currentSelectedItemDataObject),
                            metaData: lpUtils.cloneObject(currentSelectedItemMetaDataObject)
                        };
                        updateModelData();
                    }
                }
            });
        }

        function updateModelData(){
            self.logger.debug('[start] handling search result from Engagement History UMS service.');
            self.model.set(self.getModelPaths().data, createDataModelDictionary('chatData'));
            self.model.set(self.getModelPaths().metadata, createDataModelDictionary('metaData'));
            self.model.set(self.getModelPaths().array, createChatDataArray());
            self.model.set(self.getModelPaths().count, response.count);

            if (self.getStatus() !== BASE.STATES.FETCHED) {
                self.setState(BASE.STATES.FETCHED, "ok", response.count);
            }

            self.logger.debug('found ' + response.count + ' conversations from the results object.');
            self.logger.debug('[end] handling search result from Engagement History UMS service.');

            // resetting the error count.
            self.errorsCount = 0;

            function createChatDataArray() {
                var retVal = [];
                _.each(response.data, function (item) {
                    retVal.push(item.chatData);
                });
                return retVal;
            }

            function createDataModelDictionary(section) {
                var retVal = {};
                _.each(response.data, function (item) {
                    retVal[item.chatData.chatInfo.chatId] = item[section];
                });
                return retVal;
            }
        }
    };


    lpAMSEngagementHistoryListController.prototype.requestSingleConversation = function(config){
        var conversationId      = config.conversationId;
        var latestAgentId       = config.latestAgentId;
        var conversationStart   = config.conversationStart || this.model.get('connectionsLogs.data.' + conversationId + '.chatInfo.startTime');
        var onSuccess           = config.onSuccess;
        var onError             = config.onError;

        var request = {
            searchType: lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES.ByConversation,
            data: {
                conversationId: conversationId,
                latestAgentId: latestAgentId
            },
            error  :  onError  ,
            success:  onSuccess
        };
        request.data.contentToRetrieve = this.service.CONTENT_BLOCKS.BASE;

        if (lpTag.WebAgent.logicController.getMessagingSdesSiteSetting()) {
            request.data.contentToRetrieve = this.service.CONTENT_BLOCKS.ALL; // FULL SINGLE OBJECT
            request.data.start = { from: conversationStart, to: -1 };
            request.data.cappingConfiguration = this.service.CAPPING_CONFIGURATION.SINGLE;
        }

        this.service.searchEngagements(request);
    };

    lpAMSEngagementHistoryListController.prototype.loadPartialConversation = function (reqObj) {
        var conversationId          = reqObj.conversationId;
        var inludeInChatModel       = reqObj.inludeInChatModel;
        var latestAgentId           = this.model.get(this.getModelPaths().metadata + '.' + conversationId + '.latestAgentId');
        var conversationStart       = this.model.get('connectionsLogs.data.' + conversationId + '.chatInfo.startTime');
        var retriesLeft             = 2;
        var intervalRef             = null;
        var requestSuccess          = false;

        var sendRequest = (function() {
            this.requestSingleConversation({
                conversationId      : conversationId            ,
                latestAgentId       : latestAgentId             ,
                conversationStart   : conversationStart         ,
                onSuccess           : onLoadSuccess.bind(this)  ,
                onError             : onLoadError.bind(this)
            });
        }).bind(this);

        sendRequest();

        intervalRef = setInterval(function () {
            if (retriesLeft) {
                sendRequest();
                --retriesLeft;
            } else {
                clearInterval(intervalRef);
            }
        }, 15000);

        // Set's the State to Fetching (Marking Single Conversation as Fetching State)
        this.model.set(this.getModelPaths().metadata + '.' + this.selectedItemId + '.state', BASE.STATES.FETCHING);

        function onLoadSuccess(response) {
            if (requestSuccess) {
                return;
            }
            clearInterval(intervalRef);
            requestSuccess = true;

            // we are deciding if we are going to keep the data of the partial response.
            // only if it's still relevant like in the list or that we need to to open an engagement, we will persist it.
            var isConversationExists = !!this.model.get(this.getModelPaths().data + '.' + conversationId);
            if (!isConversationExists && !inludeInChatModel) {
                // if we are no longer interested in this data, dispose it.
                return false;
            }
            if(response.data && response.data.length === 1){
                var rData = response.data[0];
                rData.metaData.state = BASE.STATES.FETCHED;

                this.model.set(this.getModelPaths().data + '.' + conversationId, rData.chatData);
                this.model.set(this.getModelPaths().metadata + '.' + conversationId, rData.metaData);

                if(inludeInChatModel){
                    var channelSource = this.model.get('chats.' + conversationId + '.chatInfo.channelSource');
                    var originContext = this.model.get('chats.' + conversationId + '.chatInfo.originContext');
                    var chatData = lpUtils.cloneObject(rData.chatData);
                    if (!chatData.chatInfo) {
                        chatData.chatInfo = {};
                    }
                    chatData.chatInfo.channelSource = channelSource;
                    chatData.chatInfo.originContext = originContext;
                    this.model.set('chats.' + conversationId, chatData);
                }

                var conversationEvents = rData.chatData && rData.chatData.chatInfo && rData.chatData.chatInfo.events && rData.chatData.chatInfo.events.event;
                if(conversationEvents){
                    var conversationPhotos = _.filter(conversationEvents, function(item){
                       return item.contentType === "hosted/file" && item.isImage === true;
                    });

                    var conversationAudio = _.filter(conversationEvents, function(item){
                        return item.contentType === "hosted/file" && item.isAudio === true;
                    });

                    this.model.set("images." + conversationId, conversationPhotos);
                    this.model.set("audio." + conversationId, conversationAudio);
                }
            }
        }

        function onLoadError() {
            if (!retriesLeft) {
                this.model.set(this.getModelPaths().metadata + '.' + conversationId + '.state', BASE.STATES.ERROR);
                this.logger.error('failed to fetch single conversation record from EngagementHistory.', 'loadPartialConversation', conversationId);
            }
        }
    };

    lpAMSEngagementHistoryListController.prototype.handleSearchError = function () {
        this.logger.error('failed to fetch data for Engagement History UMS.');

        // bumping the error count.
        this.errorsCount++;

        if (this.errorsCount === this.settings.maxErrorsBeforeDisplayErrorState) {
            this.setState(BASE.STATES.ERROR);
        }
    };

    lpAMSEngagementHistoryListController.prototype.handlePollingCallback = function (previousRequest) {
        this.logger.debug('updating the polling arguments for Engagement History UMS service.');

        // making sure the request doesn't exceed the configured days into the past
        // if the end time is now
        if (previousRequest && previousRequest.data && previousRequest.data.start) {
            // we make sure the start time is less than configured days in the past
            var now = new Date().getTime();
            var maxTimeDiffInMilliSeconds = MAX_TIME_DIFF;
            previousRequest.data.start.to = now;
            if (previousRequest.data.start.from && (now - previousRequest.data.start.from > maxTimeDiffInMilliSeconds)) {
                previousRequest.data.start.from = now - maxTimeDiffInMilliSeconds;
            }
        }
    };

    lpAMSEngagementHistoryListController.prototype.createRequestDataObject = function () {
        var usePolling = {state: false};
        var queryParams = lpUtils.cloneObject(this.settings.defaultSearch.query);
        var bodyData = lpUtils.cloneObject(this.settings.defaultSearch.body);
        // the ui instructions.
        var query = this.lastQuery;
        var searchType;

        if (query.searchArea === "chatId" && query.searchTag !== "") {
            bodyData.conversationId = query.searchTag;
            searchType = lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES.ByConversation;
        }
        else {
            searchType = this.isManagerViewMode ? lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES.All
                : lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES.ByAgent;
            this.BuildRequestData(query, queryParams, bodyData, usePolling);
        }

        var requestDataObject = {
            searchType: searchType,
            query: queryParams,
            data: bodyData,
            error: this.handleSearchError.bind(this),
            success: this.handleSearchSuccess.bind(this)
        };

        if (usePolling.state) {
            _.assign(requestDataObject, {
                keepPollingOnError: true,
                pollingTimeout: lpTag.WebAgent.logicController.getPollingRefreshRateFromSiteSettings("le.agent.msgHistory.refreshRate", this.settings.poolingInterval),
                pollingCallback: this.handlePollingCallback.bind(this)
            });
        }

        requestDataObject.data.contentToRetrieve = this.service.CONTENT_BLOCKS.BASE;
        if (lpTag.WebAgent.logicController.getMessagingSdesSiteSetting()) {
            requestDataObject.data.contentToRetrieve = this.service.CONTENT_BLOCKS.LIST;
            requestDataObject.data.cappingConfiguration = this.service.CAPPING_CONFIGURATION.LIST;
        }

        return requestDataObject;
    };

    lpAMSEngagementHistoryListController.prototype.BuildRequestData = function (query, queryParams, bodyData, usePolling) {
        if (!query.hasOwnProperty('filters')) {
            query.filters = lpUtils.cloneObject(this.settings.defaultSearchUIData.filters);
        }

        for (var key in query) {
            if (query.hasOwnProperty(key)) {
                switch (key) {
                    case    "limit":
                        queryParams[key] = query[key];
                        break;
                    case    "sortTag":
                        queryParams.sort = query[key] + ":" + query.sortOrder;
                        break;
                    case    "skip":
                        queryParams.offset = query[key];
                        break;
                    case    "searchTag":
                        if (query[key] !== "") {
                            bodyData.keyword = query[key];
                        }
                        break;
                    //case    "chatStart":
                    //    if (typeof query[key].startDate !== 'undefined') {
                    //        bodyData.start.from = new Date(query[key].startDate).getTime();
                    //    }
                    //    if (typeof query[key].endDate !== 'undefined') {
                    //        if (query[key].endDate === "Now") {
                    //            bodyData.start.to = -1;  // tell the API we want the current time
                    //            usePolling.state = true;
                    //        } else {
                    //            bodyData.start.to = new Date(query[key].endDate).getTime();
                    //        }
                    //    }
                    //    break;

                    case "filters":
                        var filters = query[key];
                        for (var subKey in filters) {
                            if (filters.hasOwnProperty(subKey)) {
                                switch (subKey) {
                                    case "status":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "skillIds":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "latestConversationQueueState":
                                        if(filters[subKey]) {
                                            bodyData[subKey] = filters[subKey];
                                        }
                                        break;
                                    case "agentIds":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "agentGroupIds":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "device":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "source":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "start":
                                        if (filters[subKey].to === "Now") {
                                            bodyData[subKey].to = -1;  // tell the API we want the current time
                                            usePolling.state = true;
                                        }
                                        else {
                                            bodyData[subKey].to = filters[subKey].to;
                                        }
                                        bodyData[subKey].from = filters[subKey].from;
                                        break;
                                    case "responseTime":
                                        if (!_.isEmpty(filters[subKey])) {
                                            bodyData[subKey] = objectiveDurationInMilliseconds(filters[subKey]);
                                        }
                                        break;
                                    case "mcs":
                                        if (!_.isEmpty(filters[subKey])) {
                                            switch (filters[subKey].status) {
                                                case "1":
                                                case "-1":
                                                    bodyData.alertedMcsValues = [filters[subKey].status];
                                                    break;
                                                case "2":
                                                    bodyData[subKey] = {
                                                        from: filters[subKey].from,
                                                        to: filters[subKey].to
                                                    };
                                                    break;
                                            }

                                        }
                                        break;
                                    case "csat":
                                        if (!_.isEmpty(filters[subKey])) {
                                            bodyData[subKey] = numericDropDownToBodyData(filters[subKey]);
                                        }
                                        break;
                                    case "duration":
                                        if (!_.isEmpty(filters[subKey])) {
                                            bodyData[subKey] = durationToSeconds(filters[subKey]);
                                        }
                                        break;
                                    case "summary":
                                        bodyData[subKey] = filters[subKey] ? filters[subKey] : null;
                                        break;
                                    case "sdeSearch":
                                        var keyword = filters[subKey] ? filters[subKey] : null;
                                        bodyData[subKey] = {
                                            personalInfo: keyword,
                                            customerInfo: keyword,
                                            userUpdate: keyword
                                        };
                                        if (lpTag.WebAgent.logicController.getMessagingSdesSiteSetting()) {
                                            bodyData[subKey].marketingCampaignInfo = keyword;
                                            bodyData[subKey].lead = keyword;
                                            bodyData[subKey].purchase = keyword;
                                            bodyData[subKey].viewedProduct = keyword;
                                            bodyData[subKey].vehicleOfInterest = keyword;
                                            bodyData[subKey].cartStatus = keyword;
                                            bodyData[subKey].serviceActivity = keyword;
                                            bodyData[subKey].visitorError = keyword;
                                            bodyData[subKey].searchContent = keyword;
                                        }
                                        break;
                                    case "nps":
                                        if (!_.isEmpty(filters[subKey])) {
                                            bodyData[subKey] = numericDropDownToBodyData(filters[subKey]);
                                        }
                                        break;
                                    case "fcr":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                    case "surveyBotConversations":
                                        if(filters[subKey]) {
                                            bodyData[subKey] = filters[subKey];
                                        }
                                        break;
                                    case "surveyIds":
                                        if(filters[subKey] && filters[subKey].surveyIds) {
                                            bodyData[subKey] = (filters[subKey] && filters[subKey].surveyIds) ? filters[subKey].surveyIds.split(",") : null;
                                        }
                                        break;
                                    case "questionBrick":
                                        bodyData[subKey] = filters[subKey] ? filters[subKey] : null;
                                        break;
                                    case "invalidFreeTextAnswer":
                                        if(filters[subKey]) {
                                            bodyData[subKey] = filters[subKey];
                                        }
                                        break;
                                    case "questionTypeAndFormatToRetrieve":
                                        if (!_.isEmpty(filters[subKey])) {
                                            bodyData[subKey] = {
                                                type: "custom",
                                                format: "open"
                                            };
                                        }
                                        break;
                                    case "answerText":
                                        bodyData[subKey] = (filters[subKey]) ? filters[subKey].split(",") : null;
                                        break;
                                }
                            }
                        }
                        break;
                }
            }
        }
    };

    lpAMSEngagementHistoryListController.prototype.getChatObjectByChatId = function (chatId) {
        return this.model.get(this.getModelPaths().data + '.' + chatId);
    };

    lpAMSEngagementHistoryListController.prototype.ensureModelData = function (chatId) {
        var historyModel = this.getChatObjectByChatId(chatId);
        if(historyModel && !lpTag.WebAgent.logicController.isInMyEngagements(chatId)){
            historyModel.datasource = WebAgentUtils.DATA_SOURCES.HISTORY;
            this.model.set('chats.' + chatId, lpUtils.cloneObject(historyModel));
        }
    };

    lpAMSEngagementHistoryListController.prototype.openEngagement = function (options) {
        var chatId = options.chatId;
        var chatModel = this.getChatObjectByChatId(chatId);
        var consumerId = chatModel.visitorInfo.visitorId;

        if (!lpTag.WebAgent.logicController.isInMyEngagements(chatId)) {
            this.ensureModelData(chatId);
            if(chatModel && chatModel.chatInfo.messagingState == lpAMSController.CONVERSATION_STATES.CLOSE && chatModel.isPartial) {
                this.loadPartialConversation({conversationId: chatId, inludeInChatModel: true});
            }
            lpTag.WebAgent.amsConversationController.openEngagement({chatId: chatId});
        }

        // send a focus request to the visitor orb.
        if (consumerId) {
            window.App.viewEventsHandler.fireEvent({
                appName: consumerId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED
            });
        }
    };

    lpAMSEngagementHistoryListController.prototype.getDownloadUrl = function (data) {
        lpFileSharingController.getInstance().getDownloadUrl(data);
    };


    //PRIVATE util Functions
    /**
     * Converts duration start and end to seconds according to given unit
     * This function uses fall-through switch-case statement intentionally - a 'falls through' for jshint ignore is given.
     * @param {{start: String, end: String, unit: String}} duration
     * @returns {{from: number=, to: number=}|undefined}
     */
    function durationToSeconds(duration) {

        if (!duration) {
            return;
        }

        var multiplyFactor = 1;

        switch (duration.unit) {
            case "days":
                multiplyFactor *= 24;
            /* falls through */
            case "hours":
                multiplyFactor *= 60;
            /* falls through */
            case "minutes":
                multiplyFactor *= 60;
        }

        var res = {};
        if (_.isNumber(duration.start)) {
            res.from = duration.start * multiplyFactor;
        }

        if (_.isNumber(duration.end)) {
            res.to = duration.end * multiplyFactor;
        }

        return res;
    }

    function numericDropDownToBodyData(filterSubKey) {
        if(_.isEmpty(filterSubKey.from) && _.isEmpty(filterSubKey.to)) {
            return undefined;
        }
        var obj = {};
        if(!_.isEmpty(filterSubKey.from)) {
            obj.from = filterSubKey.from.text;
        }
        if(!_.isEmpty(filterSubKey.to)) {
            obj.to = filterSubKey.to.text;
        }
        return obj;
    }


    function objectiveDurationInMilliseconds(result) {
        if (!result) {
            return;
        }
        var resDuration = durationToSeconds({
            unit: result.durationUnit,
            start: result.longerThan,
            end: result.shorterThan,
        });

        for (var key in resDuration) {
            resDuration[key] *= 1000;
            resDuration[key] += (new Date()).getTime();
        }

        //return undefined for unecessary values
        switch (result.comparisonMethod) {
            case DurationInputViewController.COMPARISON_OPTIONS.shorter:
                resDuration.from = undefined;
                break;
            case DurationInputViewController.COMPARISON_OPTIONS.longer:
                resDuration.to = undefined;
                break;
            case DurationInputViewController.COMPARISON_OPTIONS.between:
                break;
            default:
                break;
        }

        return resDuration;
    }

    return lpAMSEngagementHistoryListController;

});
